
<component
  :is="as"
  :class="['cta-card card', { active }]"
  v-bind="$attrs"
  v-on="$listeners"
>
  <icon :name="icon" />
  <h5>{{ title }}</h5>
  <p>{{ description }}</p>
</component>
